import { useAdminLinkMonitor } from "@/hooks/useAdminLinkMonitor";

export default function LinkMonitorBootstrap() {
  useAdminLinkMonitor({ autoRun: true });
  return null;
}
